import React from "react";
import GestionCategories from "./GestionCategories";

// One responsive workspace keeps forms, details and permission checks shared.
export default function ResponsiveCategories(props) {
  return <GestionCategories {...props} />;
}
